import { loading } from 'State/actions';
import * as types from './types';
import { SubmitType } from '../../helpers';

export const getHouseholdCategoricalTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CONTROL_INFO_TYPES_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('stucasetype');

      dispatch({
        type: types.CONTROL_INFO_GET_TYPES,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.CONTROL_INFO_TYPES_FETCH_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.CONTROL_INFO_TYPES_FETCHING, false));
  };
};

export const editHouseholdCategoricalType = (caseType, submitType) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CONTROL_INFO_TYPES_SUBMITTING, true));

    try {
      const path = `stucasetype${
        submitType === SubmitType.Edit ? '/edit' : ''
      }`;
      await MPWWebApi.postGenericInsertUpdate(path, caseType);

      dispatch({
        type: types.CONTROL_INFO_TYPES_SUBMIT_SUCCESS,
        payload: submitType,
      });
      dispatch(getHouseholdCategoricalTypes());
    } catch (error) {
      dispatch({
        type: types.CONTROL_INFO_TYPES_SUBMIT_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.CONTROL_INFO_TYPES_SUBMITTING, false));
  };
};

export const deleteHouseholdCategoricalType = caseTypeId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CONTROL_INFO_TYPES_SUBMITTING, true));

    try {
      await MPWWebApi.postGenericDelete('stucasetype', caseTypeId);
      dispatch({
        type: types.CONTROL_INFO_TYPES_SUBMIT_SUCCESS,
        payload: SubmitType.Delete,
      });
      dispatch(getHouseholdCategoricalTypes());
    } catch (error) {
      dispatch({
        type: types.CONTROL_INFO_TYPES_SUBMIT_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.CONTROL_INFO_TYPES_SUBMITTING, false));
  };
};

export const clearHouseholdCategoricalTypesErrorSuccess = () => {
  return {
    type: types.CONTROL_INFO_TYPES_CLEAR_ERROR_SUCCESS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/householdCategoricalTypes/actions.js